var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11643_47473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.775 4.56563L12.15 0.403125C12.075 0.365625 12 0.365625 11.8875 0.403125L0.2625 4.56563C0.1125 4.64062 0 4.75313 0 4.94063C0 5.09063 0.1125 5.24063 0.225 5.27813L4.9875 6.96563V7.34063C4.9875 9.89062 6.375 12.2906 8.5875 13.5281C9.6 14.0906 10.7625 14.3906 11.925 14.3906H12.075C13.2375 14.3906 14.3625 14.0906 15.4125 13.5281C17.625 12.2531 19.0125 9.89062 19.0125 7.34063V6.96563L20.775 6.32812V9.55313H20.6625C20.25 9.55313 19.95 9.89062 19.95 10.2656V12.4031C19.95 12.5906 20.1 12.7781 20.325 12.7781H21.975C22.1625 12.7781 22.35 12.6281 22.35 12.4031V10.2656C22.35 9.85312 22.0125 9.55313 21.6375 9.55313H21.525V6.06563L23.775 5.27813C23.925 5.24063 24 5.09063 24 4.94063C24 4.75313 23.8875 4.64062 23.775 4.56563Z",
    fill: "#20A8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3629 13.0127C16.8754 13.4627 16.3504 13.8752 15.7504 14.2127C14.5879 14.8502 13.3504 15.1877 12.0754 15.1877H11.9254C10.6504 15.1877 9.37539 14.8502 8.25039 14.2127C7.65039 13.8752 7.12539 13.4627 6.63789 13.0127C3.78789 13.5752 1.65039 16.0877 1.65039 19.0877V23.2502C1.65039 23.4377 1.80039 23.6252 2.02539 23.6252H21.9754C22.1629 23.6252 22.3504 23.4752 22.3504 23.2502V19.0502C22.3504 16.0502 20.1754 13.5752 17.3629 13.0127Z",
    fill: "#20A8E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11643_47473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.53b1770f99c6cbdf0dfb0b391746bce9.svg";
export { ForwardRef as ReactComponent };